var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 835.7 778.5",
    style: {
      enableBackground: "new 0 0 835.7 778.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.4,0L0,159.6l171.5,138l246.4-153.7C417.8,143.9,246.4,0,246.4,0z M0,431.6l246.4,161.6l171.5-143.9 L171.5,297.6C171.5,297.6,0,431.6,0,431.6z M417.8,449.4l173.4,143.9l244.4-159.6l-169.5-136C666.2,297.6,417.8,449.4,417.8,449.4z  M835.7,159.6L591.3,0L417.8,143.9l248.3,153.7L835.7,159.6z M419.8,480.9L246.4,624.8l-72.9-49.3v55.2l246.4,147.8l246.4-147.8 v-55.2l-74.9,49.3C591.3,624.8,419.8,480.9,419.8,480.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxIcon);
export default __webpack_public_path__ + "static/media/Dropbox_Icon.e2857313.svg";
export { ForwardRef as ReactComponent };